import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { GzDashboardsAppNirvanaDataProvider } from '../dataProvider/GzDashboardsAppNirvanaDataProvider';

export class GzDashboardAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, GzDashboardsAppNirvanaDataProvider);
  }
}
